import {message} from "antd";

export function copyToClipboardUtils(title, record, ignoreFields = []) {
    let formatRowData = `${title} Details:\n`;

    Object.keys(record).forEach((key) => {
        if (ignoreFields.includes(key)) {
            return;
        }

        const value = record[key];
        if (value) {
            const formattedKey = key
                .replace(/([A-Z])/g, ' $1')  // Add space before uppercase letters
                .replace(/_/g, ' ')          // Replace underscores with spaces
                .replace(/^\w/, (c) => c.toUpperCase()); // Capitalize the first letter

            formatRowData += `${formattedKey}: ${value}\n`;
        }
    });

    navigator.clipboard
        .writeText(formatRowData)
        .then(() => {
            message.success(`${title} details copied to clipboard`);
        })
        .catch(() => {
            message.error("Failed to copy data");
        });
}

export const handleCopyUtils = async (textToCopy, setCopied, duration = 2) => {
    try {
        await navigator.clipboard.writeText(textToCopy);
        setCopied(true);

        message.success({
            content: "Link copied to clipboard!",
            key: "copyMsg",
            duration: duration
        });

        setTimeout(() => setCopied(false), 2000);
    } catch (err) {
        message.error("Failed to copy!");
    }
};
